module.exports = __webpack_public_path__ + "img/94.b6d27ba0.svg";